export default __webpack_public_path__ + "static/media/location-icon.b6bec462.svg";